import IconCard, { CardDescription, CardValue } from "components/company/cards/IconCard";
import type { IAmericanCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/AmericanCompanyIssuerTopLevel.generated";
import { LandmarkIcon } from "lucide-react";
import { FormattedMessage } from "react-intl";
import colors from "tailwindcss/colors";

interface ExchangeRegistrationDateCardProps {
  issuer: IAmericanCompanyIssuerTopLevelFragment;
}

export default function ExchangeRegistrationDateCard({ issuer }: ExchangeRegistrationDateCardProps) {
  return (
    <IconCard
      primaryColor={colors.violet[600]}
      secondaryColor={colors.violet[50]}
      icon={<LandmarkIcon className="h-4 w-4" />}
    >
      <CardValue>{issuer.listingExchange === "NYS" ? "NYSE" : issuer.exchange}</CardValue>
      <CardDescription>
        <FormattedMessage defaultMessage="Listagem" id="2OH80F" description="Listing exchange card" />
      </CardDescription>
    </IconCard>
  );
}
